(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-audience-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    document.querySelectorAll('[data-sense-parallax]').forEach(function (section) {
      var bg = section.querySelector('[data-sense-parallax-bg]');
      if (!bg) return;
      var ticking = false;

      function update() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight;
        // progress: 0 when section enters viewport, 1 when it's exited
        var progress = Math.min(Math.max((vh - rect.top) / (vh + rect.height), 0), 1);
        var translateY = (progress - 0.5) * 40; // subtle vertical drift
        var scale = 1.05 + progress * 0.1; // zoom in as it scrolls through
        bg.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-formula-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-sense-count-wrap]').forEach(function (wrap) {
      var nums = wrap.querySelectorAll('[data-sense-count]');
      if (!nums.length) return;

      function animate(el) {
        var target = parseInt(el.getAttribute('data-target'), 10) || 0;
        if (reduceMotion) { el.textContent = target; return; }
        var start = 0;
        var duration = 900;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(start + (target - start) * eased);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      if (!('IntersectionObserver' in window)) {
        nums.forEach(animate);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { io.observe(n); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sense-hero]').forEach(function (hero) {
      var wrap = hero.querySelector('[data-sense-tilt]');
      var img = hero.querySelector('.sense-hero__image');
      if (!wrap) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Hover tilt (desktop only)
      if (!reduceMotion && window.matchMedia('(hover: hover)').matches) {
        wrap.addEventListener('mousemove', function (e) {
          var rect = wrap.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width - 0.5;
          var y = (e.clientY - rect.top) / rect.height - 0.5;
          wrap.style.transform = 'perspective(900px) rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg)';
        });
        wrap.addEventListener('mouseleave', function () {
          wrap.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg)';
        });
      }

      // Scroll-linked zoom: image scales slightly as hero leaves viewport
      if (!reduceMotion && img) {
        var ticking = false;
        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var rect = hero.getBoundingClientRect();
            var vh = window.innerHeight;
            var progress = Math.min(Math.max((vh - rect.top) / (vh + rect.height), 0), 1);
            var scale = 1 + progress * 0.08;
            img.style.transform = 'scale(' + scale + ')';
            ticking = false;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sense-pdp]').forEach(function (pdp) {
      var mainImg = pdp.querySelector('#sense-pdp-main-img');
      pdp.querySelectorAll('[data-sense-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          pdp.querySelectorAll('[data-sense-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            mainImg.style.opacity = 0;
            setTimeout(function () {
              mainImg.src = thumb.getAttribute('data-full');
              mainImg.style.opacity = 1;
            }, 120);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sense-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var steps = document.querySelectorAll('.sense-timeline [data-sense-reveal]');
    if (!steps.length) return;
    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () { entry.target.classList.add('is-visible'); }, i * 70);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    steps.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
